<template>
  <div class="Logo">

    <span class="Logo-segment">Benjamin Drummond</span>

    <span class="Logo-plus">+</span>

    <span class="Logo-segment">Sara Joy Steele</span>

  </div>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style>
@import 'properties';

.Logo {
  font-weight: 600;
  font-size: 15px;
  line-height: 1.2em;
  text-decoration: none;
  user-select: none;
  color: var(--c-white) !important;
  -webkit-font-smoothing: antialiased;

  @media (min-width: 375px) {
    font-size: 18px;
  }

  @media (min-width: 600px) {
    font-size: 15px;
  }

  @media (min-width: 640px) {
    font-size: 18px;
  }
}

.Logo-segment {
  display: inline-block;
}

.Logo-plus {
  color: var(--c-blue);
}
</style>



// WEBPACK FOOTER //
// Logo.vue?4d57dea7